import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { actionLog } from "../../constants/actionTypes";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import {
  errorActionLogDownload,
  errorActionLogs,
  errorBetweenDatesLogs,
  successActionLogDownload,
  successActionLogs,
  successBetweenDatesLogs,
} from "../actions/actionLog";
import { exportActionLogsApi, fetchActionLogsList, fetchBetweenDatesLogsList } from "../api/actionLog";

export function* getActionLogsList({ payload }) {
  try {
    const data = yield call(fetchActionLogsList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successActionLogs(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.Failure);
      yield put(errorActionLogs(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.Failure);
    yield put(errorActionLogs(err));
  }
}

export function* getBetweenDatesActionLogsList({ payload }) {
  try {
    const data = yield call(fetchBetweenDatesLogsList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successBetweenDatesLogs(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.Failure);
      yield put(errorBetweenDatesLogs(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.Failure);
    yield put(errorBetweenDatesLogs(err));
  }
}

export function* getActionLogExport({ payload }) {
  try {
    const data = yield call(exportActionLogsApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successActionLogDownload(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.Failure);
      yield put(errorActionLogDownload(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.Failure);
    yield put(errorActionLogDownload(err));
  }
}

export function* actionLogRootSaga() {
  yield takeLatest(actionLog.REQUEST_ACTION_LOGS, getActionLogsList);
  yield takeLatest(actionLog.REQUEST_BETWEEN_DATES, getBetweenDatesActionLogsList);
  yield takeLatest(actionLog.REQUEST_ACTION_LOG_DOWNLOAD, getActionLogExport);
}

export default function* rootSaga() {
  yield all([fork(actionLogRootSaga)]);
}
